module.exports = __webpack_public_path__ + "img/ic_12_clock.943c85f7.svg";